import Vue from 'vue';
import VueMeta from 'vue-meta';
import App from './App';
import router from './core/router';
import store from './store';

import '@/styles/app.scss';

import './core/runtime';

Vue.use(VueMeta);

Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js